module.exports = __webpack_public_path__ + "img/al_03.daa7d99a.png";